import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/gyno-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Gynaecology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  // const scrollToSection = (section) => {
  //   sectionsRef[section].current.scrollIntoView({ behavior: "smooth",block:"center" });
  // };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };


  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=Obstetrics, Gynaecology and Fetal Medicine`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);
  

  const navigate = useNavigate();

  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
          <div className="section-content">
              <p className='page-heading'>Obstetrics, Gynaecology & Fetal Medicine</p>

              <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                  <p className="page-subtitle">
                      Cutting-edge Care in Obstetrics, Gynecology, and Fetal 
                      <br /> 
                      Medicine for Women's Health at Every Stage.
                  </p>
              </div>

              <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                  <p className="page-subtitle">
                      Cutting-edge Care in Obstetrics, Gynecology, and Fetal Medicine for Women's Health at Every Stage.
                  </p>
              </div>
              
              <div className="page-box">
                  <div className="box-content">
                      <p>Caritas Matha Hospital's Obstetrics, Gynaecology & Fetal Medicine
                        department provides comprehensive and compassionate care for women
                        at all life stages. Our expert team uses advanced technologies and
                        best practices to ensure the highest quality of care. We offer
                        services such as prenatal care, high-risk pregnancy management,
                        gynaecological surgeries, and fetal diagnostics.</p>
                  </div>
                  <div className="box-image">
                      <img src={BannerImage} alt="Emergency Medicine Banner"/>
                  </div>
              </div>
          </div>
      </section>
      <section className="dept-section">
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {["overview", "treatment", "facilities", "doctors"].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="content-heading">Overview</p>
            {/* Overview content here */}
            <p>
              The Obstetric, Gynaecology & Fetal Medicine department at Caritas
              Matha Hospital provides comprehensive care for women at all stages
              of life, from pregnancy and childbirth to gynecological health and
              fertility. Our experienced team of specialists is dedicated to
              offering personalized and advanced treatments in a compassionate
              and supportive environment.
            </p>
            <p>
              Our department is equipped with the latest medical technology and
              facilities to ensure the highest standard of care. We offer a wide
              range of services including painless labour options, high-risk
              pregnancy management, and advanced infertility treatments. Our
              well-equipped labour rooms feature continuous fetal monitoring,
              and our ultrasound services provide detailed scans with 3D/4D and
              Doppler imaging. We also provide expert care for preterm labour
              and support vaginal births after cesarean (VBAC).
            </p>
            <p>
              In addition to obstetric services, we offer comprehensive
              gynecological care. Our surgical expertise includes minimally
              invasive hysteroscopic and laparoscopic procedures, as well as
              open surgeries for complex conditions. We also provide specialized
              oncology services for cervical, endometrial, and ovarian cancers,
              along with HPV vaccinations and colposcopy screenings. Our
              department is dedicated to improving women's health through
              innovative treatments, personalized care, and a patient-centered
              approach.
            </p>
          </div>
          <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>
            {/* Treatment content here */}
            <p className="sub-heading">Obstetrics : </p>

            <ul>
              <li>
                <span className="subtitle">Normal Delivery : </span> We offer a well-equipped labour room with
                continuous fetal monitoring (CTG) throughout labour to ensure
                the safety and well-being of both mother and baby.
              </li>
              <br />
              <li>
                <span className="subtitle">Painless Labour : </span>Painless labour options, including epidural
                analgesia, are available to make the childbirth experience as
                comfortable as possible.
              </li>
              <br />
              <li>
                <span className="subtitle">High-Risk Pregnancy : </span>Specialized care for high-risk pregnancies,
                including those with conditions like diabetes, hypertension,
                cardiac issues, and seizures.
              </li>
              <br />
              <li>
                <span className="subtitle">Vaginal Birth After Cesarean (VBAC) : </span>We support and offer VBAC
                for eligible patients.
              </li>
              <br />
              <li>
                <span className="subtitle">Preterm Labour : </span>Facilities to cater to preterm labour and ensure
                the best outcomes for premature babies.
              </li>
              <br />
              <li>
                <span className="subtitle">Trained Obstetricians : </span>Continuous support and monitoring by
                trained obstetricians throughout labour.
              </li>
            </ul>

            <p className="sub-heading">Gynecology : </p>

            <ul>
              <li>
                <span className="subtitle">Ultrasound Services : </span>On-site OB/GYN scans, including 3D/4D and
                Doppler scans, conducted by fetal medicine specialists.
              </li>
              <br />
              <li>
                <span className="subtitle">Infertility Treatments : </span>Comprehensive infertility treatments,
                including follicular studies, ovulation induction, and
                intrauterine insemination (IUI).
              </li>
              <br />
              <li>
                <span className="subtitle">Hysteroscopic Surgery : </span>Advanced hysteroscopic surgeries for
                polypectomy, myomectomy, septal resection, and diagnostic
                procedures.
              </li>
              <br />
              <li>
                <span className="subtitle">Laparoscopic Surgery : </span>Minimally invasive laparoscopic surgeries,
                including cystectomy, myomectomy, lap-assisted vaginal
                hysterectomy, and diagnostic laparoscopy.
              </li>
              <br />
              <li>
                <span className="subtitle">Open Surgeries : </span>Open myomectomy and total abdominal hysterectomy
                for complex gynecological conditions.
              </li>
              <br />
              <li>
                <span className="subtitle">Ectopic Pregnancy : </span>Medical and surgical management of ectopic
                pregnancies.
              </li>
              <br />
              <li>
                <span className="subtitle">Pelvic Floor Repair : </span>Cystocele and rectocele repair, as well as
                transvaginal tape operations (TVTO).
              </li>
            </ul>

            <p className="sub-heading">Oncology : </p>
            <ul>
              <li>
                <span className="subtitle">Gynecologic Oncology Surgeries : </span>Specialized surgeries for
                cervical, endometrial, and ovarian cancers.
              </li>
              <br />
              <li>
                <span className="subtitle">HPV Vaccines : </span>Vaccination for the prevention of human
                papillomavirus (HPV) infections.
              </li>
              <br />
              <li>
                <span className="subtitle">Colposcopy : </span>Advanced screening for cervical, endometrial, and
                ovarian cancers.
              </li>
            </ul>
          </div>
          <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            {/* Facilities content here */}
            <p>
             <span className="subtitle">Labor Rooms : </span>
             <br />
             State-of-the-art labour room equipped for continuous fetal monitoring and various pain management options.
           </p>

           <p>
             <span className="subtitle">Ultrasound Technology : </span>
             <br />
             Comprehensive ultrasound facilities, including 3D/4D and Doppler scans, available within the outpatient department.
           </p>

           <p>
             <span className="subtitle">Fetal Medicine Specialists : </span>
             <br />
             Expert care for complex fetal conditions and high-risk pregnancies.
           </p>

           <p>
             <span className="subtitle">Infertility Treatment Unit : </span>
             <br />
             Advanced treatments for infertility, including IUI and ovulation induction.
           </p>

           <p>
             <span className="subtitle">Minimally Invasive Surgery : </span>
             <br />
             Cutting-edge hysteroscopic and laparoscopic surgical facilities.
           </p>

           <p>
             <span className="subtitle">Oncology Services: </span>
             <br />
             Dedicated facilities for the screening and surgical management of gynecologic cancers.
           </p>

           <p>
             <span className="subtitle">Pelvic Floor Repair : </span>
             <br />
             Specialized treatment for pelvic floor disorders.
           </p>
          </div>

          <div ref={sectionsRef.doctors} className="doctors">
              <p className="content-heading">Doctors</p>
              {doctors.length > 0 ? (
                <div className='doctorbox-container'>
                    {doctors.map(doctor => (
                      <div key={doctor.id} className="doctorbox">
                          <div className="doctor-box">
                              <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                              <div className='doctor-details'>
                                  <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                  <p>{doctor['designation']}</p>
                                  <p>{ doctor.available_time }</p>
                                  <br/>
                                  {parseInt(doctor.appointment_enabled) === 1 && (
                                      <p>
                                          <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                              Book An Appointment <FaChevronRight />
                                          </a>
                                      </p>
                                  )}
                              </div>
                          </div>
                          <div className='arrow-section'>
                              <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                          </div>
                      </div>
                    ))}
                </div>
              ) : (
                  <p>No doctors available in this department.</p>
              )}
          </div>
        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Gynaecology;